<template>
  <BaseLayout>
    <div class="flex flex-wrap">
      <div class="mb-5 w-full sm:mb-0 sm:w-1/4">
        <h4 class="text-2xl font-medium leading-tight">Recent Alerts</h4>
      </div>
      <div class="w-full sm:w-3/4 sm:max-w-[630px] sm:pl-8">
        <div v-if="isLoading">Loading events...</div>
        <NoData
          v-else-if="!isLoading && !deviceEventsItems.length"
          title="No events yet"
        >
        </NoData>
        <template v-else>
          <DeviceEvent
            v-for="event in deviceEventsItems"
            :key="event.id"
            :description="event.description"
            :date="event.created_at"
            class="mb-2"
          />
          <nav class="text-gpx_terracotta-200 mt-4 flex">
            <button
              class="border-gpx_gray-700 text-gpx_gray-100 -ml-px rounded-l-[3px] border px-3 py-2"
              :class="
                page === 1
                  ? 'pointer-events-none opacity-40'
                  : 'hover:bg-gpx_gray-800 hover:text-gpx_red-100'
              "
              :disabled="page === 1"
              @click="page--"
            >
              ‹
            </button>
            <button
              class="border-gpx_gray-700 text-gpx_gray-100 -ml-px rounded-r-[3px] border px-3 py-2"
              :class="
                !hasNext
                  ? 'pointer-events-none opacity-40'
                  : 'hover:bg-gpx_gray-800 hover:text-gpx_red-100'
              "
              :disabled="!hasNext"
              @click="page++"
            >
              ›
            </button>
          </nav>
        </template>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { formatTimeAgo } from '@/filters';
import { mapGetters, mapActions } from 'vuex';
import BaseLayout from '@/layouts/BaseLayout.vue';
import NoData from '@/components/_common/NoData.vue';
import DeviceEvent from '@/components/device/_common/DeviceEvent.vue';
import { setTitle } from '@/utils/title';

export default {
  components: {
    NoData,
    BaseLayout,
    DeviceEvent,
  },
  data() {
    return {
      isLoading: false,
      ids: [],
      page: 1,
      perPage: 10,
      hasNext: false,
    };
  },
  created() {
    setTitle('Alerts');
  },
  beforeMount() {
    this.loadDeviceEvents();
  },
  computed: {
    ...mapGetters({
      deviceEventsByIds: 'deviceEvent/byIds',
      accountId: 'auth/accountId',
    }),
    deviceEventsItems() {
      return this.deviceEventsByIds(this.ids);
    },
  },
  watch: {
    page() {
      this.loadDeviceEvents();
    },
  },
  methods: {
    formatTimeAgo,
    ...mapActions({
      fetchDeviceEvents: 'deviceEvent/fetchByAccountId',
    }),
    loadDeviceEvents() {
      this.isLoading = true;
      this.fetchDeviceEvents({
        accountId: this.accountId,
        params: {
          page: this.page,
          per_page: this.perPage,
        },
      })
        .then((res) => {
          const items = res.data.data;
          this.ids = items.map((item) => item.id);
          this.hasNext = items.length === this.perPage;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
